import { useBreakpointSelector } from '~/techstyle-shared/react-components';

const smallBreakpoint = { maxWidth: 1024, name: 'small' };
const breakpoints = [smallBreakpoint, { minWidth: 1025, name: 'large' }];

export default function useMaxSwatchesToRender() {
  // using smallBreakpoint as the fallback in case none match.
  // don't think that should be possible, but it guarentees that this will
  // never return null.
  const breakpoint = useBreakpointSelector(breakpoints, smallBreakpoint);

  if (breakpoint.name === 'large') {
    return 5;
  } else {
    // keep small the default case, better to possibly show less than to overflow
    return 4;
  }
}
